import { createContext, useContext, useMemo, useState } from "react";
import { getLocalStorage, useLocalStorage, } from "./useLocalStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useLocalStorage("persist:user", null);
  const [userMenu, setUserMenu] = useLocalStorage("userMenu", null);
  const [save, setSave] = useLocalStorage('userId',null);
  const [col, setCol] = useLocalStorage("col", null);
  const [notice, setNotice] = useLocalStorage("notice", null);

  // call this function when you want to authenticate the user
  const login = async (data,save) => {
    setIsAuthenticated(true);
    setUser(data);
    setUserMenu(data.menu_list);
    if(save){setSave(JSON.stringify(data?.user_id))}
    if (data?.level_no === 3) { // 교육원이라면
      const localNotice = getLocalStorage('notice')
      setNotice({
        ...localNotice,
        general: {...localNotice?.general, open: true},
        deliver: {...localNotice?.deliver, open: true},
        deliverPay: {...localNotice?.deliverPay, open: true}
      });
    }
  };

  // call this function to sign out logged in user
  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    setUserMenu(null);
    setCol(null);
    // user 정보만 날리게 수정
    window.localStorage.removeItem('persist:user');
    window.localStorage.removeItem('userMenu');
    window.localStorage.removeItem('openMenuInfo');
    window.localStorage.removeItem('col');
    // window.localStorage.clear();
    window.sessionStorage.clear();
  };


  const value = useMemo(
    () => ({
      user,
      isAuthenticated,
      userMenu,
      login,
      logout,

    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
